<template>
	<div class="containerDebitDetail">

		<h4>Dados da empresa</h4>

		<div class="infos-row">

			<div class="infos">
				<h6>Razão social</h6>
				<h2>{{ divida.loja.loj_razao }}</h2>
			</div>

			<div class="infos">
				<h6>Nome fantasia</h6>
				<h2>{{ divida.loja.loj_fantasia }}</h2>
			</div>

			<div class="infos">
				<h6>CNPJ</h6>
				<h2>{{ cnpjMask(divida.loja.loj_cpf_cnpj) }}</h2>
			</div>

		</div>

		<div
			:key="contrato.con_contrato"
			v-for="contrato in divida.contratos">
			<div style="display: flex; justify-content: space-between; align-items: center">
				<h4 style="text-align: left">PARCELAS</h4>
				<h4 style="text-align: right">CONTRATO {{ contrato.con_contrato }}</h4>
			</div>
	
			<div class="infos-row parcelas-box">
	
				<table class="table-parcelas">
					<tr>
						<th>Parcela</th>
						<th>Vencimento</th>
						<th>Dias em atraso</th>
						<th>Valor</th>
					</tr>
	
					<tr
						:key="parcela.par_prestacao"
						v-for="(parcela) in contrato.parcelas">
						<td>{{ parcela.par_prestacao === "0" ? "À vista" : parcela.par_prestacao }}</td>
						<td>{{ parcela.par_vencimento }}</td>
						<td>{{ diasEmAtraso(parcela) }}</td>
						<td>R$ {{ parcela.corrigido[formaPagamento] | formatarDinheiro }}</td>
					</tr>
				</table>
	
			</div>
		</div>
	</div>
</template>

<script lang="js">
import moment from "moment";

import { mapState, mapActions } from "vuex";
import globalMethods from "@/mixins/globalMethods";

import ButtonDefault from "@/components/buttons/ButtonDefault";
import PaymentOptionsDebit from "@/views/documentDebits/MyDebits/components/PaymentOptionsDebit";

export default {
	name: "DetailsDebit",

	components: { PaymentOptionsDebit, ButtonDefault },

	mixins: [globalMethods],

	props: {
		divida: {
			type: Object,
			required: true
		},

		conContrato: {
			type: String,
			required: true
		}
	},

	data() {
		return {
			showDetails: null,
		};
	},

	computed: {
		...mapState({
			parceiro: (estado) => estado.parceiroConfig.nome,
			parceiroConfig: (estado) => estado.parceiroConfig,
			pesCodigo: (estado) => estado.pesCodigo,
			lojas: (estado) => estado.passosRetornarDividas.lojas,
			formaPagamento: (estado) => estado.formaPagamento,
		}),
	},

	mounted() {
		this.lojas.forEach(loja => {
			this.action_salvar_etapa({
				pes_codigo: this.pesCodigo,
				esn_fk_ets_codigo: 33,
				emp_codigo: this.parceiroConfig.emp_codigo,
				loj_codigo: loja.loj_codigo
			});
		});
	},

	methods: {
		...mapActions(["action_salvar_etapa"]),

		diasEmAtraso(parcela) {
			if (parcela.par_vencimento === null || parcela.par_vencimento == undefined) return "---";

			else {
				let par_vencimento = moment(parcela.par_vencimento, "DD/MM/YYYY").format("MM/DD/YYYY");
				return moment(par_vencimento).diff(moment(), "days") * -1;
			}
		}
	}
};
</script>

<style scoped>
.containerDebitDetail {
	width: 100%;
	box-sizing: border-box;
	max-width: 750px;
	padding: 30px;
	background: var(--whiteColor);
	border-radius: 40px;
	box-shadow: 0 1px 2px rgba(3, 27, 78, 0.16);
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-content: center;
	margin-bottom: 100px;
}

.header-debits {
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
	box-sizing: border-box;
	width: 100%;
	max-width: 750px;
	cursor: pointer;
}

h3 {
	margin-bottom: 30px;
	color: #031b4e;
	font-family: "Roboto Black";
	text-transform: uppercase;
	font-size: 16px;
	text-align: center;
}

.header-debits i {
	font-size: 48px;
	color: #031b4e;
}

.infos-row {
	margin: 10px 0;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;
}

.infos {
	padding: 10px 20px;
}

.infos h6 {
	color: #5b6987;
	font-family: "Roboto";
	font-size: 11px;
	margin-bottom: 3px;
}

.infos h2 {
	color: #031b4e;
	font-family: "Roboto Black";
	font-size: 14px;
}

h4 {
	color: #031b4e;
	font-family: "Roboto Black";
	text-transform: uppercase;
	font-size: 16px;
	background: #f5f6fa;
	padding: 10px;
	flex: 1;
	text-align: center;
}

.table-parcelas {
	width: 100%;
	text-align: center;
}

.table-parcelas th {
	color: #031b4e;
	font-family: "Roboto Black";
	font-size: 14px;
	height: 50px;
}

tr:nth-child(even) {
	background-color: #f9f9f9;
}

.table-parcelas td {
	color: #5b6987;
	font-family: "Roboto";
	font-size: 14px;
	height: 30px;
}

.parcelas-box {
	max-height: 400px;
	overflow-y: auto;
}
</style>
